<template>
  <div class="home-events flex-col section">
    <homeTitleVue txt="RESEARCH" toMore="/research" />
    <ul class="flex-row justify-start home-event-list flex-wrap">
      <li v-for="item in data" :key="item.id">
        <HomeResearchBlockVue :data="item" />
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import homeTitleVue from "./home-title.vue";
import HomeResearchBlockVue from "./HomeResearchBlock.vue";
import { useFetchList } from "../../../hooks/fetch-list";
import { api } from "../../../utils/apis";
export default defineComponent({
  name: "HomeResearchEvents",
  components: { homeTitleVue, HomeResearchBlockVue },
  setup(props, ctx) {
    const { data } = useFetchList({
      api: api.research.list,
      initQuery: {
        page: 1,
        page_size: 8,
      },
      ctx,
    });
    // 此处应该有防抖函数
    return {
      data,
    };
  },
});
</script>
<style lang="scss" scoped>
.home-events {
  li {
    margin: 0 69px 26px 0;
  }
  .home-event-list {
    padding: 0;
    margin-top: 30px;
  }
}
</style>
